export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14480.4b85baa0.jpg";